export const capitalizeFirstLetter = (input: string): string => {
	if (input === null || input === undefined) {
		throw new Error('input is null or undefined');
	}
	const inputHasThanOneWord = input.split(' ').length > 1;
	if (inputHasThanOneWord) {
		throw new Error('input has more than one word');
	}
	return `${input.charAt(0).toUpperCase()}${input.slice(1).toLowerCase()}`;
};

export const capitalizeFirstLetterOfWords = (input: string): string => {
	if (input === null || input === undefined) {
		throw new Error('input is null or undefined');
	}
	return input
		.split(' ')
		.map(word => capitalizeFirstLetter(word))
		.join(' ');
};
